import { render, staticRenderFns } from "./Fortune.vue?vue&type=template&id=0f5f3efe&scoped=true&"
import script from "./Fortune.vue?vue&type=script&lang=js&"
export * from "./Fortune.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f5f3efe",
  null
  
)

export default component.exports